import { PricingTier } from '@/types'
import { SECTION_IDS } from '@/utils'

/**
 * Pricing tiers for website packages
 */
export const pricingTiers: PricingTier[] = [
  {
    id: 'pricing-starter',
    name: 'Starter Website',
    priceLabel: 'Starting from $1,499',
    features: [
      '5-page professional website',
      'Mobile responsive design',
      'Contact form integration',
      'Basic SEO setup',
      'Google Maps integration',
      '30-day support included',
    ],
    isPopular: false,
    ctaText: 'Get Started',
    ctaLink: `#${SECTION_IDS.CONTACT}`,
  },
  {
    id: 'pricing-growth',
    name: 'Growth Website',
    priceLabel: 'Starting from $2,999',
    features: [
      'Everything in Starter',
      'Advanced custom design',
      'Lead generation optimization',
      'Complete local SEO setup',
      'Service area pages',
      'Integration with scheduling tools',
      '90-day support included',
    ],
    isPopular: true,
    ctaText: 'Get Started',
    ctaLink: `#${SECTION_IDS.CONTACT}`,
  },
  {
    id: 'pricing-premium',
    name: 'Lead Generation Website',
    priceLabel: 'Starting from $4,999',
    features: [
      'Everything in Growth',
      'Premium custom design',
      'Advanced SEO strategy',
      'Conversion rate optimization',
      'Blog setup with initial content',
      'CRM integration',
      '6-month support included',
      'Monthly performance reports',
    ],
    isPopular: false,
    ctaText: 'Get Started',
    ctaLink: `#${SECTION_IDS.CONTACT}`,
  },
]
